module.exports = __webpack_public_path__ + "img/state2.7060d340.webp";